export default __webpack_public_path__ + "static/media/homebg.af98985a.jpg";